module.exports = __webpack_public_path__ + "img/dark_mark_in_sky.7018e139.jpg";